import styled from 'styled-components'


export const HeaderContainer = styled.div`
    background-color: black;
    padding-top: 2rem;
    padding-bottom: 2rem;
    width: 100%;
`
export const HeaderTitle = styled.p`
    text-align: center;
    font-size: 2.5rem;
    color: white;
`

export const HeaderDescription = styled.p`
    color: white;
    text-align: center;
    font-size: 1.5rem;
`

export const HeaderLink = styled.p`
    color: white;
    font-size: 1.5rem;
    text-align: center;
`